export default __webpack_public_path__ + "static/media/bus-1.14b52f77.png";